import { useCallback, useEffect, useState } from "react";
import ChannelPreferences from "./ChannelPreferences";
import ESPChart from "./ESP";
import Salvations from "./Salvations";
import memberPotential from "../../../assets/svg/memberPotential.svg";
import PropertyType from "../../../assets/svg/household-income.svg";
import ChildrenAge from "../../../assets/svg/children-age.svg";
import HeadHouseHold from "../../../assets/svg/head-houseHold.svg";
import AtriumApi from "../../../api";
import { RiEdit2Fill } from "react-icons/ri";
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
} from "@chakra-ui/modal";
import { useDisclosure } from "@chakra-ui/hooks";
import DarkButton from "components/actions/DarkButton";
import toast from "react-hot-toast";
import { useAuth } from "hooks/useAuth";
import Loader from "components/loader/Loader";

const ProgressCard = ({ icon, title, value, percentage }) => {
  return (
    <div className="bg-white dark:bg-navy-800 rounded-2xl shadow p-[19px] pr-10 py-[27px] mb-4">
      <div className="flex items-center gap-4">
        <div className="bg-[#F4F7FE] dark:bg-[#0b1437] rounded-full mb-4 flex items-center justify-center w-12 h-12 ">
          {icon}
        </div>

        <div className="flex-1">
          <div className="flex justify-between items-center mb-5">
            <h3 className="text-lg font-semibold text-[#1E2A53] dark:text-white">
              {title}
            </h3>
            <p className="text-2xl font-bold text-[#1E2A53] dark:text-white">
              {value}
            </p>
          </div>

          <div className="w-full h-2 bg-gray-200 rounded-full mt-2">
            <div
              className="h-2 bg-green-600 rounded-full"
              style={{ width: `${percentage}%` }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
};

const ChurchInsights = () => {
  const [insights, setInsights] = useState({});
  const [loading, setLoading] = useState(true);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [formDataLoading, setFormDataLoading] = useState(false);
  const [formData, setFormData] = useState({
    month: "",
    year: "",
  });

  const { user } = useAuth();

  // get church insight and salvation api
  useEffect(() => {
    const fetchInsights = async () => {
      try {
        setLoading(true);
        const res = await AtriumApi.get("/v2/demographics/insights");
        setInsights(res?.data?.insights || {});
      } catch (error) {
        console.error("Error fetching church insights:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchInsights();
  }, []);

  // get Salvations API

  const fetchSalvation = useCallback(async () => {
    if (!user?.id) return;
    try {
      setLoading(true);
      const res = await AtriumApi.get(`/v2/salvation/${user?.id}`);

      if (res) {
        setLoading(false);
        setFormData(res?.data?.data || {});
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching church insights:", error);
    }
  }, [user?.id]);
  useEffect(() => {
    fetchSalvation();
  }, [fetchSalvation]);

  // post api of  the salvation

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAddSalvation = async () => {
    try {
      if (formData.month === "" || formData.year === "") {
        return toast.error("All fields are required");
      }
      setFormDataLoading(true);
      const res = await AtriumApi.post("/v2/salvation", formData);
      if (res) {
        setFormDataLoading(false);
        toast.success("Salvation added successfully");
        fetchSalvation();
        onClose();
      }
    } catch (error) {
      setFormDataLoading(false);
      console.error("Error fetching church insights:", error);
      toast.error(error?.response?.data?.message);
    }
  };

  // if (loading) return <p>Loading...</p>;
  if (!insights || Object.keys(insights).length === 0)
    return (
      <p className="text-center text-gray-500 dark:text-gray-300">
        No insights available
      </p>
    );

  const data = [
    {
      id: 1,
      icon: <img src={HeadHouseHold} alt="head-houseHold" />,
      title: "Head of household age",
      value: insights.headOfHouseholdAge,
      percentage: parseFloat(insights.headOfHouseholdAge) || 0,
    },
    {
      id: 2,
      icon: <img src={PropertyType} alt="property-type" />,
      title: "Home Ownership",
      value: `${Math.round(parseFloat(insights.homeownerPercentage) || 0)}%`,
      percentage: parseFloat(insights.homeownerPercentage) || 0,
    },
    {
      id: 3,
      icon: <img src={ChildrenAge} alt="children-age" />,
      title: "Likelihood to have children under 18",
      value: `${Math.round(
        parseFloat(insights.childrenUnder18Percentage) || 0
      )}%`,
      percentage: parseFloat(insights.childrenUnder18Percentage) || 0,
    },
  ];

  return (
    <div>
      {/* First row */}
      {loading ? (
        <div className="flex items-center justify-center h-[50vh] w-full">
          <Loader />
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <div className="bg-white dark:bg-navy-800 shadow-lg rounded-[20px] p-[20px]">
            <p className="text-[18px] font-[700] text-[#2B3674] dark:text-white pb-2">
              Channel Preferences
            </p>
            <ChannelPreferences data={insights.topChannelPreferences || []} />
          </div>

          <div className="bg-white dark:bg-navy-800 shadow-lg rounded-[20px] p-[30px]">
            <p className="text-[18px] font-[700] text-[#2B3674] dark:text-white pb-2">
              ESP
            </p>
            <p className="text-[12px]">Engagement Score Potential</p>
            <ESPChart />
          </div>

          <div className="bg-white dark:bg-navy-800 shadow-lg rounded-[20px] p-[30px]">
            <div className="flex justify-between items-center">
              <p className="text-[18px] font-[700] text-[#2B3674] dark:text-white pb-2">
                Salvations
              </p>
              <RiEdit2Fill
                onClick={onOpen}
                size={20}
                className="text-[#2B3674] dark:text-white cursor-pointer"
              />
            </div>

            <div className="flex justify-center gap-4 mt-6">
              <div>
                <p className="text-[12px] text-center mb-2">Monthly</p>
                <Salvations data={formData?.month} />
              </div>
              <div>
                <p className="text-[12px] text-center mb-2">Yearly</p>
                <Salvations data={formData?.year} />
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Second row */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 my-8">
        <div className="flex flex-col gap-4">
          {/* Avg Income */}
          <div className="bg-white dark:bg-navy-800 shadow rounded-[20px] p-3 flex flex-col items-center text-center">
            <div className="bg-[#F4F7FE] dark:bg-[#0b1437] p-4 rounded-full mb-4 flex items-center justify-center">
              <img
                src={memberPotential}
                alt="memberPotential"
                className="w-8 h-8"
              />
            </div>
            <p className="text-[18px] font-bold text-[#2B3674] dark:text-white mb-1">
              Avg Church Household Income
            </p>
            <p className="text-[14px] font-medium text-[#707EAE] dark:text-gray-400">
              ${insights?.avgMin} - ${insights?.avgMax}
            </p>
          </div>

          {/* Giving Potential */}
          <div className="bg-white dark:bg-navy-800 shadow rounded-[20px] p-3 flex gap-2 items-center">
            <div className="bg-[#F4F7FE] dark:bg-[#0b1437] p-4 rounded-full flex items-center justify-center">
              <img src={PropertyType} alt="PropertyType" className="w-8 h-8" />
            </div>
            <div>
              <p className="text-[18px] font-bold text-[#2B3674] dark:text-white mb-1">
                ${insights?.tenPercentMin} - ${insights?.tenPercentMax}
              </p>
              <p className="text-[14px] font-medium text-[#707EAE] dark:text-gray-400">
                Total Member Giving Potential
              </p>
            </div>
          </div>

          {/* Property Distribution */}
          <div className="bg-white dark:bg-navy-800 shadow rounded-[20px] p-3 pr-6 flex gap-4 items-center">
            <div className="bg-[#F4F7FE] dark:bg-[#0b1437] p-4 rounded-full flex items-center justify-center">
              <img src={PropertyType} alt="Property Type" className="w-8 h-8" />
            </div>
            <div className="flex-1">
              <p className="text-[18px] font-bold text-[#2B3674] dark:text-white mb-3">
                Type of Property
              </p>
              <div className="flex justify-between">
                <div className="space-y-1">
                  {Object.keys(insights?.propertyDistribution || {}).map(
                    (type) => (
                      <p
                        key={type}
                        className="text-[14px] font-medium text-[#707EAE] dark:text-gray-400"
                      >
                        {type}
                      </p>
                    )
                  )}
                </div>
                <div className="space-y-1 text-right">
                  {Object.entries(insights?.propertyDistribution || {}).map(
                    ([type, percentage]) => (
                      <p
                        key={type}
                        className="text-[14px] font-medium text-[#2B3674] dark:text-white"
                      >
                        {percentage}
                      </p>
                    )
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="w-full">
          {data.map((item) => (
            <ProgressCard
              key={item.id}
              icon={item.icon}
              title={item.title}
              value={item.value}
              percentage={item.percentage}
            />
          ))}
        </div>
      </div>

      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        {/* Overlay with correct opacity */}
        <ModalOverlay className="bg-white/10 backdrop-blur-lg shadow-xl" />

        <ModalContent className="!m-auto !w-[90%] max-w-[500px] rounded-2xl  dark:bg-white/10 backdrop-blur-lg shadow-xl">
          <ModalCloseButton className="absolute right-4 top-4 z-10" />

          <ModalBody p={0}>
            <div className=" w-full min-h-[150px] rounded-2xl">
              {/* Optional gradient overlay */}

              {/* Inputs pinned at the bottom */}
              <div className="mt-12 px-8 pb-8 space-y-4">
                <div>
                  <label className="dark:text-white text-black font-semibold block mb-1">
                    Monthly
                  </label>
                  <input
                    className="!border-whit mr-3 flex h-12 w-full items-center justify-center rounded-full border dark:bg-white/0 bg-black/0 p-3 text-sm text-black dark:text-white outline-none dark:placeholder:text-white"
                    name="month"
                    placeholder="Write monthly value"
                    type="number"
                    value={formData.month}
                    onChange={handleChange}
                  />
                </div>
                <div>
                  <label className="dark:text-white text-black font-semibold block mb-1">
                    Yearly
                  </label>
                  <input
                    className="!border-whit mr-3 flex h-12 w-full items-center justify-center rounded-full border dark:bg-white/0 bg-black/0 p-3 text-sm text-black dark:text-white outline-none dark:placeholder:text-white"
                    name="year"
                    placeholder="Write yearly value"
                    type="number"
                    value={formData.year}
                    onChange={handleChange}
                  />
                </div>
                <DarkButton
                  disabled={formDataLoading}
                  onClick={handleAddSalvation}
                >
                  {formDataLoading ? "Saving..." : "Save"}
                </DarkButton>
              </div>
            </div>
          </ModalBody>
        </ModalContent>
      </Modal>
    </div>
  );
};

export default ChurchInsights;
